export const calculateNextPage = (
  totalPlayers: number,
  playersPerPage: number,
  previousPage: number,
) => {
  const maxPagesToDisplay =
    Math.floor(totalPlayers / playersPerPage) + (totalPlayers % playersPerPage === 0 ? 0 : 1)

  if (previousPage === maxPagesToDisplay) {
    // reset to first page
    return 1
  }

  return previousPage + 1
}



// WEBPACK FOOTER //
// ./src/helpers/category-results.ts